import React from "react";
import {
    Box,
    Card,
    Typography,
    Chip,
    Stack,
    TextField,
    IconButton,
    Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import CheckIcon from "@mui/icons-material/Check";
import { BADGE_COLORS, getBadgeStyles } from "../../../../components/ui/badgeColors";

/**
 * Lista mobile de líneas del traspaso con cards
 */
export default function LineasTraspasoList({ lineas, onUpdateUnidades, onCommitUnidades, onDeleteLinea }) {
    if (!lineas?.length) {
        return (
            <Alert severity="info" sx={{ mt: 2 }}>
                No hay líneas añadidas.
            </Alert>
        );
    }

    return (
        <Stack spacing={2}>
            {lineas.map((l) => (
                <Card
                    key={l.codigo}
                    sx={{
                        borderLeft: "4px solid #cc071e",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        "&:hover": {
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        },
                    }}
                >
                    <Box sx={{ p: 2 }}>
                        {/* Header */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#212529" }}>
                                {l.codigo}
                            </Typography>
                            <Chip
                                label={`${l.unidades} ud`}
                                size="small"
                                sx={getBadgeStyles(BADGE_COLORS.RED)}
                            />
                        </Box>

                        {/* Nombre producto */}
                        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#495057", mb: 1.5 }}>
                            {l.nombre}
                        </Typography>

                        {/* Stock info */}
                        <Stack spacing={0.75}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 12 }}>
                                <Typography sx={{ fontSize: 12, color: "#6c757d", fontWeight: 600 }}>
                                    Stock origen:
                                </Typography>
                                <Typography sx={{ fontSize: 13, color: "#495057", fontWeight: 600 }}>
                                    {l.stockOrigen}
                                </Typography>
                                <Typography sx={{ fontSize: 12, color: "#6c757d" }}>·</Typography>
                                <Typography sx={{ fontSize: 12, color: "#6c757d", fontWeight: 600 }}>
                                    Stock destino:
                                </Typography>
                                <Typography sx={{ fontSize: 13, color: "#495057", fontWeight: 600 }}>
                                    {l.stockDestino}
                                </Typography>
                            </Box>

                            {l.barras && (
                                <Typography sx={{ fontSize: 11, color: "#6c757d", fontStyle: "italic" }}>
                                    Barras: {l.barras}
                                </Typography>
                            )}
                        </Stack>

                        {/* Acciones */}
                        <Box sx={{ display: "flex", gap: 1, mt: 2, pt: 1.5, borderTop: "1px solid #e9ecef" }}>
                            <TextField
                                size="small"
                                type="number"
                                label="Unidades"
                                value={l.unidadesInput ?? String(l.unidades ?? "")}
                                inputProps={{ min: 1 }}
                                onChange={(e) => onUpdateUnidades(l.codigo, e.target.value)}
                                onBlur={() => onCommitUnidades(l.codigo)}
                                sx={{
                                    flex: 1,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#fff",
                                    },
                                }}
                            />
                            <IconButton
                                size="small"
                                onClick={() => onCommitUnidades(l.codigo)}
                                sx={{
                                    color: "#198754",
                                    "&:hover": {
                                        backgroundColor: "rgba(25,135,84,0.08)",
                                    },
                                }}
                            >
                                <CheckIcon />
                            </IconButton>
                            <IconButton
                                size="small"
                                onClick={() => onDeleteLinea(l.codigo)}
                                sx={{
                                    color: "#dc3545",
                                    "&:hover": {
                                        backgroundColor: "rgba(220,53,69,0.08)",
                                    },
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </Card>
            ))}
        </Stack>
    );
}
